export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  getButtonState() {
    const { age } = this.formValues

    this.showButton = !!(age || age === 0)
  },
})
